import { render, staticRenderFns } from "./XeroAccept.vue?vue&type=template&id=e1a5e0e8"
import script from "./XeroAccept.vue?vue&type=script&lang=js"
export * from "./XeroAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports